export default __webpack_public_path__ + "static/media/bluepipes-2018.4648d4a5.png";